module.exports = __webpack_public_path__ + "img/research_7.7546fd99.jpg";